
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  SelectedItemService,
  ManualFeatureSelectionProperties,
  NavigationFeatureType
} from '@jeppesen-foreflight/jmkw-extensions';

@Component({
  selector: 'test-core-mock-search-popout',
  standalone: true,
  imports: [],
  templateUrl: './mock-search-popout.component.html',
  styleUrl: './mock-search-popout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MockSearchPopoutComponent {
  private selectedItemService = inject(SelectedItemService);

  locations: Record<
    string,
    ManualFeatureSelectionProperties<NavigationFeatureType>
  > = {
    KATL: {
      navType: 'airport',
      latitude: 33.636917591074585,
      longitude: -84.42787170320322,
      attributeName: 'icao',
      attributeValue: 'KATL'
    } as ManualFeatureSelectionProperties<NavigationFeatureType>,
    KLAX: {
      navType: 'airport',
      latitude: 33.94222069311461,
      longitude: -118.40789794831143,
      attributeName: 'icao',
      attributeValue: 'KLAX'
    } as ManualFeatureSelectionProperties<NavigationFeatureType>,
    KSFO: {
      navType: 'airport',
      latitude: 37.61858265405491,
      longitude: -122.37533569245097,
      attributeName: 'icao',
      attributeValue: 'KSFO'
    } as ManualFeatureSelectionProperties<NavigationFeatureType>,
    SNS: {
      navType: 'navaid',
      latitude: 36.6640126870743,
      longitude: -121.60285949616213,
      attributeName: 'navaid_id',
      attributeValue: 'SNS'
    } as ManualFeatureSelectionProperties<NavigationFeatureType>,
    KSFO_B: {
      navType: 'airspace',
      latitude: 37.20355172899284,
      longitude: -122.58989095597022,
      attributeName: 'eid',
      attributeValue: '450000010101'
    } as ManualFeatureSelectionProperties<NavigationFeatureType>,
    'R-5701': {
      navType: 'airspace',
      latitude: 45.70011703531395,
      longitude: -119.82444218704059,
      attributeName: 'aspname',
      attributeValue: 'R-5701'
    } as ManualFeatureSelectionProperties<NavigationFeatureType>,
    V182: {
      navType: 'airway',
      latitude: 45.072012212126,
      longitude: -118.6436264903246,
      attributeName: 'name',
      attributeValue: 'V182'
    } as ManualFeatureSelectionProperties<NavigationFeatureType>,
    EDDF: {
      navType: 'airport',
      latitude: 50.03332738199684,
      longitude: 8.570709280003312,
      attributeName: 'icao',
      attributeValue: 'EDDF'
    } as ManualFeatureSelectionProperties<NavigationFeatureType>,
    'New Zealand': {
      navType: 'airspace',
      latitude: -42.048185991842544,
      longitude: 169.72865254727103,
      attributeName: 'aspname',
      attributeValue: 'New Zealand',
      zoomLevel: 4
    } as ManualFeatureSelectionProperties<NavigationFeatureType>
  };

  locationKeys: string[] = Object.keys(this.locations);

  onSelection(key: string) {
    const selection = this.locations[key];
    this.selectedItemService.selectFeature(selection);
  }
}
